import { Badge } from "@mantine/core";
import { TicketStatus } from "./enquiryInbox.types";

interface TicketStatusCardProps {
  ticketStatus: string;
  isSellerEscalation: boolean;
  isEscalation: boolean;
  hasFreightProtection: boolean;
}

export const TicketStatusCard = ({
  ticketStatus,
  isSellerEscalation,
  isEscalation,
  hasFreightProtection,
}: TicketStatusCardProps) => {
  return (
    <div style={{ width: "200px" }}>
      {ticketStatus === TicketStatus[TicketStatus.New].toLowerCase() && (
        <Badge size="xs" variant="filled" color="yellow">
          {ticketStatus}
        </Badge>
      )}
      {(ticketStatus === TicketStatus[TicketStatus.Open].toLowerCase() ||
        (ticketStatus === TicketStatus[TicketStatus.Pending].toLowerCase() &&
          isSellerEscalation)) && (
        <Badge size="xs" variant="filled" color="red">
          {ticketStatus}
        </Badge>
      )}
      {ticketStatus === TicketStatus[TicketStatus.Pending].toLowerCase() &&
        !isSellerEscalation && (
          <Badge size="xs" variant="filled" color="blue">
            {ticketStatus}
          </Badge>
        )}
      {ticketStatus === TicketStatus[TicketStatus.Solved].toLowerCase() && (
        <Badge size="xs" variant="filled" color="gray">
          {ticketStatus}
        </Badge>
      )}
      {ticketStatus === TicketStatus[TicketStatus.Closed].toLowerCase() && (
        <Badge size="xs" variant="filled" color="gray">
          {ticketStatus}
        </Badge>
      )}
      {ticketStatus === TicketStatus[TicketStatus.Hold].toLowerCase() && (
        <Badge size="xs" variant="filled" color="gray">
          {ticketStatus}
        </Badge>
      )}{" "}
      <span> </span>
      {isEscalation && (
        <Badge size="xs" variant="outline" color="red">
          {" "}
          Escalation{" "}
        </Badge>
      )}
      <span></span>
      {hasFreightProtection && (
        <Badge size="xs" variant="filled" color="cyan">
          {" "}
          Priority Customer{" "}
        </Badge>
      )}
    </div>
  );
};
